import React from 'react'
import '../../../base/Theme.css'
import './Raise.css';
import Slider from "rc-slider";
import ActionButton from "../action/Action";
import {miotaToIota} from "../../../../utils/Converter";

export const RAISE_STEP = miotaToIota(0.01);

const RaiseBar = ({value, min, max, onValueChanged}) => {
    return (
        <div className="RaiseSliderRoot">
            <div className="RaiseSlider">
                <ActionButton style="SliderButton DecrementButton" text={"-"} onClick={() => {
                    let newValue = value - RAISE_STEP;
                    if (newValue < min) newValue = min;

                    const intValue = Math.round(newValue * 10) / 10
                    onValueChanged(intValue);
                }}/>
                <Slider railStyle={{height: 1}} trackStyle={{height: 1}} min={min} max={max}
                        step={RAISE_STEP} value={value} onChange={(value) => {
                    onValueChanged(value);
                }}/>
                <ActionButton style="SliderButton IncrementButton" text={"+"} onClick={() => {
                    let newValue = value + RAISE_STEP;
                    if (newValue > max) newValue = max;

                    const intValue = Math.round(newValue * 10) / 10
                    onValueChanged(intValue)
                }}/>
            </div>
        </div>
    );
}

export default RaiseBar;
